import { useRef, useState } from 'react';

export const useOnMountAndChange = (
    callback: (...args: readonly unknown[]) => unknown,
    deps?: readonly unknown[],
): void => {
    const [prevValues, setPrevValues] = useState<readonly unknown[] | undefined>(deps);
    const hasRun = useRef(false);

    if (!deps) {
        callback();
        return;
    }

    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    } else {
        const hasSomeDependencyChanged = deps.some((value, index) =>
            !prevValues ? false : !Object.is(value, prevValues[index]),
        );
        if (hasSomeDependencyChanged) {
            setPrevValues(deps);
            callback();
        }
    }
};
